import React, { memo, useMemo } from 'react';
import { ReactComponent as SectionIcon } from 'features/editor/assets/icons/section.svg';
import { RenderElementProps } from 'slate-react';

import { elementTypes } from '../../constants/types';
import stringifyListWithValue from '../../utils/stringifyListWithValue';
import Box, { CollapsedLabel, RootWrapper, Title } from '../box';
import getContent from '../tags/utils/getContent';

const Section = ({
  attributes = { 'data-slate-node': 'element', ref: null },
  children = null,
  element = { type: elementTypes.SECTION, children: [] },
}: RenderElementProps) => {
  const { data } = element;

  /** For backward compatibiy */
  const content = useMemo(
    () => getContent(data?.content as string),
    [data?.content],
  );

  const sections = stringifyListWithValue(content as Record<string, string>[]);

  return (
    <div {...attributes}>
      {children}
      <Box Icon={SectionIcon}>
        <RootWrapper>
          <CollapsedLabel>Section</CollapsedLabel>
          {sections ? (
            <Title>{sections}</Title>
          ) : (
            <Title italic>No content...</Title>
          )}
        </RootWrapper>
      </Box>
    </div>
  );
};

export default memo(Section);
